import { useState, useEffect, useCallback } from "react";
import ApiService from "../../../../service/ApiService";
import { apiPaths } from "../../../../service/apiPaths";

const useMyLead = () => {
  const [leadData, setLeadData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [search, setSearch] = useState("");

  const fetchLeads = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const params = new URLSearchParams({
        page: String(page),
        limit: "10",
        search,
      });
      const response = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.myLeads}?${params.toString()}`,
      });
      setLeadData(response.data);
      setTotalPage(response.totalPages);
    } catch (err: any) {
      setError(err.message || "Failed to fetch leads");
    } finally {
      setLoading(false);
    }
  }, [page, search]);

  useEffect(() => {
    fetchLeads();
  }, [fetchLeads]);

  return {
    leadData,
    loading,
    error,
    page,
    totalPage,
    setPage,
    setSearch,
  };
};

export default useMyLead;